// source: messages/schemas/envelope.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

var google_protobuf_any_pb = require("google-protobuf/google/protobuf/any_pb.js");
goog.object.extend(proto, google_protobuf_any_pb);
var messages_enums_payload_type_pb = require("../../messages/enums/payload_type_pb.js");
goog.object.extend(proto, messages_enums_payload_type_pb);
var messages_schemas_source_pb = require("../../messages/schemas/source_pb.js");
goog.object.extend(proto, messages_schemas_source_pb);
goog.exportSymbol("proto.Envelope", null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Envelope = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Envelope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Envelope.displayName = "proto.Envelope";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Envelope.prototype.toObject = function (opt_includeInstance) {
    return proto.Envelope.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Envelope} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Envelope.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        source:
          (f = msg.getSource()) &&
          messages_schemas_source_pb.Source.toObject(includeInstance, f),
        type: jspb.Message.getFieldWithDefault(msg, 2, 0),
        payload:
          (f = msg.getPayload()) &&
          google_protobuf_any_pb.Any.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Envelope}
 */
proto.Envelope.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Envelope();
  return proto.Envelope.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Envelope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Envelope}
 */
proto.Envelope.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new messages_schemas_source_pb.Source();
        reader.readMessage(
          value,
          messages_schemas_source_pb.Source.deserializeBinaryFromReader,
        );
        msg.setSource(value);
        break;
      case 2:
        var value = /** @type {!proto.PayloadType} */ reader.readEnum();
        msg.setType(value);
        break;
      case 3:
        var value = new google_protobuf_any_pb.Any();
        reader.readMessage(
          value,
          google_protobuf_any_pb.Any.deserializeBinaryFromReader,
        );
        msg.setPayload(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Envelope.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Envelope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Envelope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Envelope.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_schemas_source_pb.Source.serializeBinaryToWriter,
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter,
    );
  }
};

/**
 * optional Source source = 1;
 * @return {?proto.Source}
 */
proto.Envelope.prototype.getSource = function () {
  return /** @type{?proto.Source} */ jspb.Message.getWrapperField(
    this,
    messages_schemas_source_pb.Source,
    1,
  );
};

/** @param {?proto.Source|undefined} value */
proto.Envelope.prototype.setSource = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.Envelope.prototype.clearSource = function () {
  this.setSource(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Envelope.prototype.hasSource = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional PayloadType type = 2;
 * @return {!proto.PayloadType}
 */
proto.Envelope.prototype.getType = function () {
  return /** @type {!proto.PayloadType} */ jspb.Message.getFieldWithDefault(
    this,
    2,
    0,
  );
};

/** @param {!proto.PayloadType} value */
proto.Envelope.prototype.setType = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * optional google.protobuf.Any payload = 3;
 * @return {?proto.google.protobuf.Any}
 */
proto.Envelope.prototype.getPayload = function () {
  return /** @type{?proto.google.protobuf.Any} */ jspb.Message.getWrapperField(
    this,
    google_protobuf_any_pb.Any,
    3,
  );
};

/** @param {?proto.google.protobuf.Any|undefined} value */
proto.Envelope.prototype.setPayload = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.Envelope.prototype.clearPayload = function () {
  this.setPayload(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Envelope.prototype.hasPayload = function () {
  return jspb.Message.getField(this, 3) != null;
};

goog.object.extend(exports, proto);
